export const apiRateLimitCooldownMs = 10_000;
export const apiRateLimitMessage = 'Se realizaron demasiadas solicitudes. Espera unos segundos e intenta nuevamente.';

let blockedUntil = 0;
let lastNotificationAt = 0;
const notificationListeners = new Set<(message: string) => void>();

export class ApiRateLimitError extends Error {
  readonly status = 429;

  constructor() {
    super(apiRateLimitMessage);
    this.name = 'ApiRateLimitError';
  }
}

export function ensureApiRequestAllowed(now = Date.now()) {
  if (now < blockedUntil) throw new ApiRateLimitError();
}

export function registerApiRateLimit(now = Date.now()) {
  blockedUntil = Math.max(blockedUntil, now + apiRateLimitCooldownMs);
}

export function isPublicApiRequest(path: string) {
  return path.split('?', 1)[0].startsWith('/public/');
}

export function notifyApiRateLimit(path: string, now = Date.now()) {
  if (isPublicApiRequest(path) || now - lastNotificationAt < 1_000) return;
  lastNotificationAt = now;
  for (const listener of notificationListeners) listener(apiRateLimitMessage);
}

export function subscribeApiRateLimit(listener: (message: string) => void) {
  notificationListeners.add(listener);
  return () => {
    notificationListeners.delete(listener);
  };
}

export function shouldRetryApiQuery(failureCount: number, error: unknown) {
  return !(error instanceof ApiRateLimitError) && failureCount < 1;
}

export function resetApiRateLimit() {
  blockedUntil = 0;
  lastNotificationAt = 0;
}
